<p class="validation-text" [ngClass]="{
    'text-danger': isError,
    'text-success': !isError
}"
id="{{id}}"
>
    {{message}}
</p>
